enum NavigationConstants {
    SignIn = '/',
    B2CSignIn = '/b2c-sign-in',
    SignOut = '/sign-out',
    AppOne = '/app1',
    AppTwo = '/app2',
    AppThree = '/app3',
    ExternalHome = '/external-home',
    InternalHome = '/internal-home',
}

export default NavigationConstants;